module.exports = __webpack_public_path__ + "img/0Q3A7268_L_BlackMatted.29b26ffd.jpg";